import {useCallback, useEffect, useState} from 'react';
import {Box, Grid, makeStyles} from '@material-ui/core';
import {useDispatch, useSelector} from "react-redux";
import {getHubs, moveNextPage, updateUserMetrics} from "../../../../store/actions/creator/creatorExperienceBuilder";
import clsx from 'clsx';
import Experiences from '../../../../config/creator';
import CreatorPickModal from '../../../atoms/modals/pickModal';
import UtilService from '../../../../helper/service';
import roles from "../../../../helper/roles";
import {useHistory, useLocation} from "react-router";
import CreatorBtn from "../../../atoms/creator/experienceBuilderEnterBtn";
import { Feature } from 'flagged';

let experiences: any = Experiences.experiences([]);

const useStyles = makeStyles((theme) => ({
  img: {
    width: 317,
    height: 200,
    cursor:'pointer',
    '@media (max-width: 1800px)': {
      width: 285,
      height: 166,
    },
  },
  imgSmall: {
    width: 236,
    height: 174,
    '&:hover': {
      cursor: 'pointer'
    },
    '@media (max-width: 1800px)': {
      width: 200,
      height: 'auto',
    },
  },
  checkTitle: {
    color: '#212D40',
    fontSize: 20,
    textAlign: 'center',
    fontWeight: 'bold'
  },
  disableText: {
    color: '#D9D9D9'
  },
  item: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 30,
    position: 'relative',
    '@media (max-width: 1400px)': {
      marginTop: 20,
    },
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: 60,
    '@media (max-width: 1400px)': {
      marginTop: 20,
    },
  },
  dFlexCenter: {
    display: 'flex',
    alignItems: 'center',
  },
  flex1: {
    flex: 1
  },
  tinyTitle: {
    color: '#212D40',
    fontSize: 14,
    fontWeight: 'bold',
    margin: '0 auto',
    marginTop: 5,
    justifyContent: 'center',
    width:103,
    display:'flex',
    marginBottom: 15,
  },
  tinyDescription: {
    color: '#212D40',
    fontSize: 14,
    margin: 0,
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  },
  optionText: {
    fontSize: 18,
    color: '#017AEF',
    textAlign: 'right',
    marginRight: -40,
    marginBottom: -60,
    '&:hover': {
      cursor: 'pointer',
      color: '#0f9fef'
    },
    [theme.breakpoints.down('md')]: {
      marginRight: 10,
      marginBottom: -5,
    }
  },
  square: {
    width: 103,
    height: 103,
    borderRadius: 16,
    background: '#F0F0F0',
    display: 'flex',
    margin:'0 auto',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    '@media (max-width: 1800px)': {
      width: 90,
      height: 90,
    },
    '&:hover': {
      cursor: 'pointer',
      background: '#FFCE7B'
    }
  },
  icon: {
    width: 60,
    height: 60,
    '@media (max-width: 1800px)': {
      width: 50,
      height: 50,
    },
  },
  rightIcon: {
    width: 24,
    height: 103,
    marginRight: 30,
    marginLeft: 30
  },
  hidden: {
    visibility: 'hidden',
    marginRight: 30,
    marginLeft: 30
  },
  columnCenter: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  active: {
    background: '#FFCE7B',
  },
  infoIcon: {
    width: 30,
    height: 30,
    cursor: 'pointer'
  },
  infoDiv: {
    width: 230,
    height: 'auto',
    borderRadius: 20,
    backgroundColor: '#F0F0F0',
    position: 'absolute',
    bottom: -140,
    zIndex: 100,
    padding: '15px 20px',
    fontSize: 14
  },
  infoTitle: {
    fontFamily: 'roboto-bold'
  },
  infoDescription: {
    fontFamily: 'roboto-regular'
  }
}));

function ExperienceBuilderStart() {

  const classes = useStyles();
  const { userMetrics, categories } = useSelector((state: any) => state.creatorExperienceBuilder);
  const { totalExperienceCount } = useSelector((state: any) => state.experience);
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : ""
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const [modal, setModal] = useState(false);
  const [data, setData] = useState();
  const [more, setMore] = useState([false, false]);
  const { path, content, item, otherSubmitted, modLastActivePage, asyncLastActivePage } = userMetrics;
  const [preRecordImg, setPreRecordImg] = useState("/assets/icons/pre-recorded2.svg");
  const [liveImg, setLiveImg] = useState("/assets/icons/live2.svg");
  const [experienceFormatted, setExperienceFormatted] = useState(false);
  const [overlay1, setOverlay1] = useState(false);
  const [overlay2, setOverlay2] = useState(false);

  const handleClose = () => {
    setModal(false);
  };

  useEffect(() => {
    if ((content && experienceFormatted) || content) {
      if (history.location.hash !== '#async2' && history.location.hash !== '#mod2') {
        UtilService.addHashTag(history, location.pathname, `${path === 1 ? 'async2' : 'mod2'}`);
      }
    } else {
      if (totalExperienceCount !== null) {
        if (path === 0) { // not selected yet (Pre-recorded or Live experience)
          if (totalExperienceCount === 0) {
            UtilService.addHashTag(history, location.pathname, 'first');
          } else {
            UtilService.addHashTag(history, location.pathname, 'start');
          }
        }
        if (path === 1) { // Pre-recorded is selected
          if (history.location.hash !== '#async1') {
            UtilService.addHashTag(history, location.pathname, 'async1');
          }
        } else if (path === 2) { // Live experience is selected
          if (history.location.hash !== '#mod1') {
            UtilService.addHashTag(history, location.pathname, 'mod1');
          }
        }
      }
    }
  }, [totalExperienceCount, path, content, experienceFormatted]);
  
  useEffect(() => {
    experiences = Experiences.experiences(categories)
    setExperienceFormatted(true)
  },[categories]);

  const handleKeyPress = (event: any) => {
    if (event.keyCode === 13 && otherSubmitted) {
      goNext();
    }
  };

  useEffect(() => {
    window.addEventListener('keydown', handleKeyPress);
    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  });

  useEffect(() => {
    if(path === 1){
      setPreRecordImg("/assets/icons/pre-recorded.svg")
    } else {
      setPreRecordImg("/assets/icons/pre-recorded2.svg")
    }
    if(path === 2){
      setLiveImg("/assets/icons/live.svg")
    } else {
      setLiveImg("/assets/icons/live2.svg")
    }
  },[path]);

  useEffect(() => {
    if (userMetrics.content === "OTHER") {
      const array: any = [...experiences];
      const expType=path === 1 ? 'Pre-Recorded Content' : 'Live Experiences';
      array.forEach((ele: any) => {
        if (ele.title === expType) {
          ele.children.forEach((child: any) => {
            if (child.name === 'OTHER') {
              child.subItems=[];
              child.subItems.push({icon: "", title: userMetrics.item, name: userMetrics.item})
            }
          })
        }
      });
    }
  },[userMetrics]);

  const handleMore = (index: number) => {
    const newMore = more;
    newMore[index] = !newMore[index];
    setMore(() => [...newMore])
  };

  const handleExperienceChange = (child: any) => {
    dispatch(updateUserMetrics('content', child.name))
  };

  const onNextPage = (item: string) => {
    dispatch(updateUserMetrics('item', item));
    dispatch(moveNextPage(1))
  };

  const onRemovePath = () => {
    dispatch(updateUserMetrics('otherSubmitted', false));
    dispatch(updateUserMetrics('item', ''));
    dispatch(updateUserMetrics('content', ''));
  };

  const onSubmit = (newExp: any) => {
    const array: any = [...experiences];
    const expType = path === 1 ? 'Pre-Recorded Content' : 'Live Experiences';
    array.forEach((ele: any) => {
      if (ele.title === expType) {
        ele.children.forEach((child: any) => {
          if (child.name==='OTHER') {
            child.subItems=[];
            child.subItems.push({
              icon: "",
              title: newExp.experience,
              name: newExp.experience
            })
          }
        })
      }
    });
    handleExperienceChange(data);
    dispatch(updateUserMetrics('item', newExp.experience));
    dispatch(updateUserMetrics('otherSubmitted', true));
    handleClose()
  };

  const getSubItemsLength = useCallback(() => {
    if (
      experiences[path - 1]
      && UtilService.getTitlePickcategory(experiences[path - 1].children, content)
      && UtilService.getTitlePickcategory(experiences[path - 1].children, content).subItems
    ) {
      return (UtilService.getTitlePickcategory(experiences[path - 1].children, content).subItems).length;
    }
  }, [path, experiences, content]);

  const isTrialFirstTimeBuilding = () => {
    return !!(
      UtilService.checkTrialAccess(loginUserData, roles['trial']['builder']) && totalExperienceCount !== null && totalExperienceCount === 0
    );
  };

  const clickPrerecorded = () => {
    dispatch(updateUserMetrics('path', 1));
    isTrialFirstTimeBuilding() && dispatch(updateUserMetrics('myOwn', true));
  };

  const goNext = () => {
    dispatch(updateUserMetrics('item', item));
    dispatch(moveNextPage(1));
    if (path === 1) {
      (asyncLastActivePage < 1) && dispatch(updateUserMetrics('asyncLastActivePage', 1));
    } else {
      (modLastActivePage < 1) && dispatch(updateUserMetrics('modLastActivePage', 1));
    }
  };

  const onClickLiveExperience = () => {
    const request = loginUserData.department_id ? {department_id: Number(loginUserData.department_id)} : {};
    dispatch(getHubs(apolloClient.client, request));
    dispatch(updateUserMetrics('path', 2));
  };

  return (
    <>
      <p className={clsx("creator-title", "mt-65")} >
        Let’s measure some brains!
      </p>

      <p className='creator-main-title'>
        What are you measuring?
      </p>

      <Grid container alignItems='center' justifyContent='center' spacing={1}>
        {(!content && experienceFormatted) && (
          <>
          <Feature name="feature_recorded">
            <Grid item xs={12} md={6} className={classes.item}>
              <img
                className={classes.img}
                alt="{img}"
                src={preRecordImg}
                onClick={clickPrerecorded}
                onMouseOver={e => (e.currentTarget.src = "/assets/icons/pre-recorded.svg")}
                onMouseOut={e => path === 1 ? e.currentTarget.src = "/assets/icons/pre-recorded.svg" : e.currentTarget.src = "/assets/icons/pre-recorded2.svg"}
              />
              <p className={clsx(classes.checkTitle, path === 2 && classes.disableText)}>Pre-recorded content</p>
              {!isTrialFirstTimeBuilding() && (
                <>
                  {path === 0 && <img
                    className={classes.infoIcon}
                    alt="Info Icon"
                    src={'/assets/icons/info.svg'}
                    onMouseOver={() => setOverlay1(true)}
                    onMouseOut={() => setOverlay1(false)}
                  />}
                  {overlay1 && (
                    <div className={classes.infoDiv}>
                      <div className={classes.infoTitle}>Examples include:</div>
                      <div className={classes.infoDescription}>Ads</div>
                      <div className={classes.infoDescription}>Movie Trailers</div>
                      <div className={classes.infoDescription}>Songs</div>
                      <div className={classes.infoDescription}>Videos</div>
                      <div className={classes.infoDescription}>Recorded Lessons</div>
                    </div>
                  )}
                </>
              )}
            </Grid>
            </Feature>
            <Feature name="feature_live">
            <Grid item xs={12} md={6} className={classes.item}>
              <img
                className={classes.img}
                alt="{img}"
                src={liveImg}
                onClick={onClickLiveExperience}
                onMouseOver={e => (e.currentTarget.src = "/assets/icons/live.svg")}
                onMouseOut={e => path === 2 ? e.currentTarget.src = "/assets/icons/live.svg" : e.currentTarget.src = "/assets/icons/live2.svg"}
              />
              <p className={clsx(classes.checkTitle, path === 1 && classes.disableText)}>Live experience</p>
              {!isTrialFirstTimeBuilding() && (
                <>
                  {path === 0 && <img
                    className={classes.infoIcon}
                    alt="Info Icon"
                    src={'/assets/icons/info.svg'}
                    onMouseOver={() => setOverlay2(true)}
                    onMouseOut={() => setOverlay2(false)}
                  />}
                  {overlay2 && (
                    <div className={classes.infoDiv}>
                      <div className={classes.infoTitle}>Examples include:</div>
                      <div className={classes.infoDescription}>Events</div>
                      <div className={classes.infoDescription}>Classes & Lessons</div>
                      <div className={classes.infoDescription}>Conferences</div>
                      <div className={classes.infoDescription}>Live Performances</div>
                      <div className={classes.infoDescription}>Tours & Attractions</div>
                    </div>
                  )}
                </>
              )}
            </Grid>
            </Feature>
          </>
        )}

        {content && experienceFormatted && <div>

          <div className={classes.dFlexCenter}>
            <img
              className={classes.imgSmall}
              alt="{img}"
              src={path === 1 ? "/assets/icons/pre-recorded.svg" : "/assets/icons/live.svg"}
              onClick={() => onRemovePath()}
            />

            <img
              className={classes.rightIcon}
              alt="{img}"
              src={"/assets/icons/right-arrow.svg"}
            />

            {UtilService.getTitlePickcategory(experiences[path - 1].children, content) && (
              <div className={classes.columnCenter}>
                <div className={classes.square} style={{ background: '#FFCE7B' }}>
                  <img
                    className={classes.icon}
                    alt="{img}"
                    src={UtilService.getTitlePickcategory(experiences[path - 1].children, content).icon}
                  />
                </div>
              </div>
            )}

          </div>

          <div className={classes.dFlexCenter}>
            <p className={clsx(classes.checkTitle, classes.flex1)}  >{path === 1 ? 'Pre-recorded content' : 'Live experience'}</p>

            <img
              className={classes.hidden}
              alt="{img}"
              src={"/assets/icons/right-arrow.svg"}
            />

            {UtilService.getTitlePickcategory(experiences[path - 1].children, content) && (
              <div className={classes.columnCenter}>
                <p className={classes.tinyTitle} style={{ textAlign: 'center' }}>{UtilService.getTitlePickcategory(experiences[path - 1].children, content).title.replace('/', '')}</p>
              </div>
            )}
          </div>

        </div>}

      </Grid>

      {!content && experienceFormatted && <Box mt={8} mb={1}>
        {
          experiences.map((u: any, index: number) =>
            path === index + 1 &&
            <div key={index} style={{ marginTop: index === 0 ? 0 : 0 }}>
              {u.children.length > 4 && <p className={classes.optionText} onClick={() => handleMore(index)}>
                {more[index] ? 'Less' : 'More'}
              </p>}
              <Grid container spacing={1} className={`category-column`}>
                {u.children.slice(0, more[index] ? u.children.length : 4).map((child: any, k: number) =>
                  <Grid item xs={6} md={3} className={"inner-item"} key={k}>
                    <div
                      className={clsx(classes.square, (child.name === content ||(child.name=== 'OTHER'&& modal) ) && classes.active)}
                      onClick={() => {
                        setData(child);
                        child.name !== 'OTHER' ? handleExperienceChange(child) :setModal(true)
                      }}
                    >
                      <img src={child.icon} className={classes.icon} alt="{img}" />
                    </div>
                    <p className={classes.tinyTitle}>{child.title}</p>
                    <p className={classes.tinyDescription}>{child.description}</p>
                  </Grid>)
                }
              </Grid>
            </div>)
        }
      </Box>}
      
      {
        content && experienceFormatted && getSubItemsLength() &&
        <Box className={classes.row +" "+`category-column categoty-coloum${getSubItemsLength()}`} style={{ flexWrap: 'wrap', marginTop: 20 }}>
          {
            UtilService.getTitlePickcategory(experiences[path - 1].children, content).subItems.map((x: any, index: number) =>
              <div key={index} onClick={() => onNextPage(x.name)} className={"inner-item"}>
                <div className={clsx(classes.square, item === x.name && classes.active)}>
                 <img src={x.icon?x.icon:'/assets/icons/subitem.svg'} className={classes.icon} alt="{img}" />
                </div>
                <p className={classes.tinyTitle} style={{ textAlign: 'center' }}>{x.title}</p>
              </div>)
          }
        </Box>
      }
      {otherSubmitted && <CreatorBtn isValidation={true} isEnabled={true} goNext={goNext}/>}


      <CreatorPickModal
        onClose={handleClose}
        open={modal}
        onSuccess={onSubmit}
      />

    </>

  )
}

export default ExperienceBuilderStart;